import { render, staticRenderFns } from "./InvoiceAddEditModal.vue?vue&type=template&id=96bc0be4&"
import script from "./InvoiceAddEditModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports